<template>
	<section :class="['_title-with-tag', taglineClass]">
		<div class="s-indented-title g-row">
			<div class="g-col xxl-20 lg-19 md-22 sm-24">
				<h2 class="-p-small">{{ tag }}</h2>
				<p class="-title2 g-indent">{{ title }}</p>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	tag: { type: String, default: '' },
	title: { type: String, default: '' },
	taglineClass: { type: String, default: '' },
})
</script>

<style lang="scss" scoped>
._title-with-tag {
	margin-top: rs(31, 31);
	margin-bottom: rs(60, 60);

	.-p-small {
		white-space: pre-line;
	}

	h2 {
		max-width: column-width(4);

		@include max-width($md) {
			max-width: unset;
		}
	}

	&.first-tagline {
		margin-top: rs(31, 31);
		margin-bottom: rs(60, 60);
	}
	&.second-tagline {
		margin-top: rs(82, 82);
		margin-bottom: rs(31, 31);
	}
	&.third-tagline {
		margin-top: rs(126, 10);
		margin-bottom: rs(40, 40);
	}
	&.fourth-tagline {
		margin-top: rs(42, 42);
		margin-bottom: rs(52, 52);
	}
}
</style>
